import { useEffect, useState } from 'react';
import { subscribeProducts, type ProductListResult } from '@/lib/firestoreProducts';

/**
 * Hook que envolve `subscribeProducts` em estado React. Retorna `LOADING` no
 * primeiro tick, `READY`/`ERROR` em seguida. Limpa o listener no unmount e
 * quando `tenantId` muda. *
 * Origem: sem issue — commit 92e8a3839, 2026-06-10 17:53 +0200 (aba Produtos
 * agrupados por categoria).
 *
 * Usado por: `features/products/ProductsTab.tsx`.
 *
 * Dados: `tenants/{tenantId}/products` (sem ordenação: o agrupamento por
 * categoria ordena no cliente), validado por `ProductSchema` em
 * `lib/firestoreProducts.ts`.
 *
 * Falhas conhecidas: documento fora do schema é descartado no `lib/` só com
 * `console.warn`, e erro do listener só com `console.error` — nenhum dos dois
 * chega à telemetria (CLAUDE.md "Observabilidade"; ver #926, achados).
 */
export function useProducts(tenantId: string): ProductListResult {
  const [result, setResult] = useState<ProductListResult>({ kind: 'LOADING' });

  useEffect(() => {
    if (!tenantId) {
      setResult({ kind: 'LOADING' });
      return;
    }
    setResult({ kind: 'LOADING' });
    const unsub = subscribeProducts(tenantId, setResult);
    return unsub;
  }, [tenantId]);

  return result;
}
